module.exports = __webpack_public_path__ + "img/gongzhonghao.3ee65d37.jpg";